<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <el-row :gutter=10 justify="center">
            <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                <h2>选择图片</h2>
                <ul class="el-upload-list el-upload-list--picture-card radius">
                    <VueDraggable v-model="fileList" class="center">
                        <li v-for="(item, index) in fileList" :key="item.uid"
                            class="el-upload-list__item is-success animated">
                            <img :src="item.url" alt="" class="el-upload-list__item-thumbnail">
                            <span class="el-upload-list__item-actions">
                                <!-- 预览 -->
                                <span class="el-upload-list__item-preview" @click="handlePreview(item)">
                                    <i class="fas fa-search-plus"></i>
                                </span>
                                <!-- 删除 -->
                                <span class="el-upload-list__item-delete" @click="handleRemove(index)">
                                    <i class="fas fa-trash-alt"></i>
                                </span>
                            </span>
                        </li>
                    </VueDraggable>
                </ul>
                <div class="center">
                    <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15" multiple
                        accept=".jpeg,.png,.jpg" list-type="picture-card" :before-upload="checkFileType"
                        :on-preview="handlePreview" :on-remove="handleRemove" :on-change="changeFile"
                        :auto-upload="false" v-model:file-list="fileList" style="padding-bottom: 2rem"
                        :show-file-list="false">
                        <el-icon>
                            <Plus />
                        </el-icon>
                    </el-upload>
                </div>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <h2>功能</h2>
                <div class="flex flex-col items-start gap-4">
                    <el-segmented v-model="segment" :options="options" size="large" @change="handleSegment" />
                </div>
                <el-form :model="normalForm" label-width="auto" class="radius" v-show="normalVisible">
                    <p style="font-size:2rem">普通拼接</p>
                    <p>适用于图片比例基本一致的情况</p>
                    <p>会对图片进行缩放、拉伸</p>
                    <p>图片拼接顺序为依次从左往右从上往下，拼接顺序有问题时，可以尝试重新生成</p>
                    <el-form-item>
                        <img :src="require('img/sample/sample1.png')" style="width: 100%" loading="lazy" />
                    </el-form-item>
                    <el-form-item label="图片行数">
                        <el-input-number v-model="normalForm.row" :min="1" :max="10" @change="handleChange"
                            :controls="false" />
                    </el-form-item>
                    <el-form-item label="图片列数">
                        <el-input-number v-model="normalForm.col" :min="1" :max="10" @change="handleChange"
                            :controls="false" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleConcat(fileList)">生成</el-button>
                        <el-button @click="resetNormal">重置</el-button>
                        <el-button @click="savePic">保存</el-button>
                    </el-form-item>
                </el-form>
                <el-form :model="waterfallForm" label-width="auto" class="radius" v-show="waterfallVisible">
                    <p style="font-size:2rem">瀑布流拼接</p>
                    <p>适用于图片比例各不相同的情况</p>
                    <p>会对图片进行缩放</p>
                    <p>图片拼接顺序为依次从左往右从上往下，拼接顺序有问题时，可以尝试重新生成</p>
                    <el-form-item>
                        <img :src="require('img/sample/sample2.png')" style="width: 100%" loading="lazy" />
                    </el-form-item>
                    <!-- <el-form-item label="图片总宽度">
                                <el-input-number v-model="waterfallForm.width" :min="0" @change="handleChange" />
                            </el-form-item> -->
                    <el-form-item label="瀑布流条数">
                        <el-input-number v-model="waterfallForm.num" :min="1" :max="10" @change="handleChange"
                            :controls="false" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleWaterfall(fileList)">生成</el-button>
                        <el-button @click="resetWaterfall">重置</el-button>
                        <el-button @click="savePic">保存</el-button>
                    </el-form-item>
                </el-form>
                <el-form :model="watermarkForm" label-width="auto" class="radius" v-show="watermarkVisible">
                    <p style="font-size:2rem">批量加水印</p>
                    <p>点击即赠网站同款水印</p>
                    <p>非常非常慢但是请不要反复点击……！真的会生成很多遍</p>
                    <el-form-item>
                        <el-button type="primary" @click="handleWatermark(fileList)">生成</el-button>
                        <el-button @click="saveCapture">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                <h2>效果预览</h2>
                <div class="radius" id="captureList">
                    <img id="captureResult" style="width:100%">
                </div>
                <div id="canvas" style="position:fixed;left:100%;">
                    <canvas id="cvs"></canvas>
                </div>
                <br>
                <el-dialog v-model="dialogVisible">
                    <img style="width:100%" :src="dialogImageUrl" alt="Preview Image" />
                </el-dialog>
            </el-col>
        </el-row>

    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { Plus } from '@element-plus/icons-vue'
import { ref, getCurrentInstance, onMounted } from "vue";
import { VueDraggable } from 'vue-draggable-plus'
import axios from 'axios'

const title = "图片处理"
const subtitle = "tips:保存图片时发生卡顿是正常现象，请耐心等待"

const { proxy } = getCurrentInstance()
const dialogImageUrl = ref('')
const dialogVisible = ref(false)

const segment = ref('瀑布流拼接')
const options = ['普通拼接', '瀑布流拼接', '批量加水印']

const normalForm = ref([])
normalForm.value.row = 2
normalForm.value.col = 4
const normalVisible = ref(false)

const waterfallForm = ref([])
waterfallForm.value.width = 1000
waterfallForm.value.num = 4
const waterfallVisible = ref(true)

const watermarkForm = ref()
const watermarkVisible = ref(false)
const capture = ref([])

const resetNormal = () => {
    normalForm.value.row = 2
    normalForm.value.col = 4
}

const resetWaterfall = () => {
    waterfallForm.value.width = 1000
    waterfallForm.value.num = 4
}


const handleSegment = () => {
    if (segment.value == '瀑布流拼接') {
        watermarkVisible.value = false
        normalVisible.value = false
        waterfallVisible.value = true
    } else if (segment.value == '普通拼接') {
        watermarkVisible.value = false
        waterfallVisible.value = false
        normalVisible.value = true
    } else if (segment.value == '批量加水印') {
        normalVisible.value = false
        waterfallVisible.value = false
        watermarkVisible.value = true
    }
}


const handleWaterfall = (uploadFile) => {
    if (uploadFile.length < waterfallForm.value.num) {
        proxy.$message.error('图片数量不符，请上传至少' + waterfallForm.value.num + '张图片')
        return false;
    }
    let urls = []

    dp(uploadFile)

    async function dp(uploadFile) {
        await doloop(uploadFile)
        displayPic()
    }



    async function doloop(uploadFile) {
        for (let file of uploadFile) {
            urls = await loop(file)
        }
        drawToCanvasWaterfall(urls)
        return new Promise(resolve => {
            setTimeout(() => {
                resolve()
            }, 1000);
        })
    }

    function loop(file) {
        return new Promise(resolve => {
            const blob = new Blob([file.raw], { type: ["image/png", 'image/jpg', 'image/jpeg'] })
            const url = window.URL.createObjectURL(blob)
            var img = new Image;
            img.src = url;
            img.onload = function () {//必须onload之后再画
                const w = img.width
                const h = img.height
                urls.push([url, w, h])
                resolve(urls)
            }
        })

    }
}

const drawToCanvasWaterfall = (urls) => {
    let colNum = waterfallForm.value.num

    let width = 0
    let mean_width = 0
    if (waterfallForm.value.width != 1000) {
        width = waterfallForm.value.width
    } else {
        let u = urls.sort(function (a, b) { return a < b ? 1 : -1 });
        if (u.length % 2 == 1) {
            // If length is odd 
            mean_width = u[(u.length / 2) - .5][1]
        } else {
            mean_width = (u[u.length / 2][1] + u[(u.length / 2) - 1][1]) / 2;
        }
        width = mean_width * colNum
        waterfallForm.value.width = width
    }

    let max_height = [];
    for (let i = 0; i < colNum; i++) {
        max_height.push(width / colNum / urls[i][1] * urls[i][2])
    }
    for (let j = colNum; j < urls.length; j++) {
        max_height[j % colNum] = max_height[j % colNum] + width / colNum / urls[j][1] * urls[j][2]
    }
    let height = 0
    let h = max_height.sort(function (a, b) { return a < b ? 1 : -1 });
    height = h[0]

    var cvs = document.querySelector('#cvs');
    var rate = 1;
    if (width * height > 5000 * 10000) {
        rate = width * height / 5000 / 10000;
    }
    cvs.width = width / rate;
    cvs.height = height / rate;

    var ctx = cvs.getContext('2d');
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, width, height);
    doloopDraw(urls)

    async function doloopDraw(urls) {
        for (let u = 0; u < urls.length; u++) {
            await loopDraw(urls[u], u)
        }
    }

    function loopDraw(url, u) {
        return new Promise(resolve => {
            var img = new Image;
            img.src = url[0];
            img.onload = function () {//必须onload之后再画
                let current_height = 0
                for (let k = u - colNum; k >= 0; k = k - colNum) {
                    current_height = current_height + width / colNum / urls[k][1] * urls[k][2] / rate
                }
                let current_width = (u % colNum) * width / colNum / rate
                let w = width / colNum / rate
                let h = width / colNum / urls[u][1] * urls[u][2] / rate
                ctx.drawImage(img, current_width, current_height, w, h);
                // const strDataURI = cvs.toDataURL();//获取canvas base64数据
                resolve()
            }
        })
    }
}


async function doloop(uploadFile) {
    for (let file of uploadFile) {
        urls = await loop(file)
    }
    drawToCanvasWaterfall(urls)
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, 1000);
    })
}

function loop(file) {
    return new Promise(resolve => {
        const blob = new Blob([file.raw], { type: ["image/png", 'image/jpg', 'image/jpeg'] })
        const url = window.URL.createObjectURL(blob)
        var img = new Image;
        img.src = url;
        img.onload = function () {//必须onload之后再画
            const w = img.width
            const h = img.height
            urls.push([url, w, h])
            resolve(urls)
        }
    })

}


const handleWatermark = (uploadFile) => {
    for (let file of uploadFile) {
        const formData = new FormData();
        const blob = new Blob([file.raw], { type: ["image/png", 'image/jpg', 'image/jpeg'] })
        formData.append('file', blob);
        formData.append('size', blob.size);
        axios.post('http://helloworldend.top:8000/axios', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                console.log('上传成功');
                const targetDiv = document.querySelector('#captureList');
                const newImage = document.createElement('img');
                newImage.src = response.data.image_data
                newImage.className = 'watermark'
                newImage.style.width = '100%'
                targetDiv.appendChild(newImage);
                let capture_list = capture.value
                capture.value = capture_list + [response.data.image_data]
            })
            .catch(error => {
                console.error('错误:', error);
                const statusCode = error.response.status;
                const errorMessage = error.response.data.message;
                console.error('错误:', statusCode);
                console.error('错误:', errorMessage);
                // 处理错误
            });
    }
}




const fileList = ref([])
const fileMap = ref([])
const analysisProxy = (value) => {
    return JSON.parse(JSON.stringify(value))
}

const handleRemove = (index) => {
    let newList = []
    for (let i = 0; i < fileList.value.length; i++) {
        if (i != index) {
            newList.push(fileList.value[i])
        }
    }
    fileList.value = newList
}

const handlePreview = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url
    dialogVisible.value = true
}

const changeFile = () => {

}

const submitUpload = () => {

}

const handleChange = () => {

}

const handleConcat = (uploadFile) => {
    if (normalForm.value.row * normalForm.value.col != uploadFile.length) {
        proxy.$message.error('图片数量不符，请上传' + normalForm.value.row * normalForm.value.col + '张图片')
        return false;
    }
    let urls = []

    dp(uploadFile)

    async function dp(uploadFile) {
        await doloop(uploadFile)
        displayPic()
    }

    async function doloop(uploadFile) {
        for (let file of uploadFile) {
            urls = await loop(file)
        }
        drawToCanvas(urls)
        return new Promise(resolve => {
            setTimeout(() => {
                resolve()
            }, 1000);
        })
    }

    function loop(file) {
        return new Promise(resolve => {
            const blob = new Blob([file.raw], { type: ["image/png", 'image/jpg', 'image/jpeg'] })
            const url = window.URL.createObjectURL(blob)
            var img = new Image;
            img.src = url;
            const w = img.width
            img.onload = function () {//必须onload之后再画
                const w = img.width
                const h = img.height
                urls.push([url, w, h])
                resolve(urls)
            }
        })

    }
}


const drawToCanvas = (urls) => {
    let size_height = []
    let size_width = []
    let colNum = normalForm.value.row
    let rowNum = normalForm.value.col
    for (let u = 0; u < urls.length;) {
        let min_height = Infinity
        for (let i = 0; i < colNum; i++) {
            min_height = min_height < urls[u + i][2] ? min_height : urls[u + i][2]
        }
        size_height.push(min_height)
        u = u + colNum
    }
    for (let u = 0; u < urls.length;) {
        let total_width = 0
        for (let i = 0; i < colNum; i++) {
            total_width = total_width + urls[u + i][1] / urls[u + i][2] * size_height[Math.floor(u / colNum)]
        }
        size_width.push(total_width)
        u = u + colNum
    }
    let height = 0
    let width = Infinity
    for (let s of size_width) {
        width = width < s ? width : s
    }
    for (let s = 0; s < size_height.length; s++) {
        height = height + size_height[s] / size_width[s] * width
    }

    var cvs = document.querySelector('#cvs');
    cvs.width = width;
    cvs.height = height;
    var ctx = cvs.getContext('2d');
    doloopDraw(urls)

    async function doloopDraw(urls) {
        for (let u = 0; u < urls.length; u++) {
            await loopDraw(urls[u], u)
        }
    }

    function loopDraw(url, u) {
        return new Promise(resolve => {
            var img = new Image;
            img.src = url[0];
            img.onload = function () {//必须onload之后再画
                let current_width = (u % colNum) * width / colNum
                let current_height = Math.floor(u / colNum) * height / rowNum
                let w = width / colNum
                let h = height / rowNum
                ctx.drawImage(img, current_width, current_height, w, h);
                // const strDataURI = cvs.toDataURL();//获取canvas base64数据
                resolve()
            }
        })
    }
}

const checkFileType = (file) => {
    const fileName = file.name
    const fileType = fileName.substring(fileName.lastIndexOf('.'))
    if (
        fileType === '.jpg' ||
        fileType === '.png' ||
        fileType === '.jpeg'
    ) {
        // 不处理
    } else {
        proxy.$message.error('请上传正确的图片类型')
        return false
    }
}

const savePic = () => {
    var cvs = document.querySelector('#cvs');
    var dataString = cvs.toDataURL("image/png");
    var link = document.createElement("a");
    const timeElapsed = Date.now();
    link.download = 'result' + timeElapsed + '.png';
    link.href = dataString;
    link.click();
}

const saveCapture = () => {
    var myDiv = document.querySelector('#captureList');
    var images = myDiv.querySelectorAll('.watermark');
    console.log(images)
    for (var img of images) {
        var link = document.createElement('a');
        const timeElapsed = Date.now();
        link.download = 'result' + timeElapsed + '.png';
        link.href = img.src;
        link.click();
    }
}

const displayPic = () => {
    var cvs = document.querySelector('#cvs');
    var dataString = cvs.toDataURL("image/png");
    var img = document.querySelector('#captureResult');
    img.src = dataString
}


</script>
<style scoped>
.radius {
    border: 1px solid var(--el-border-color);
    border-radius: 0;
    padding: 2rem;
}

p {
    color: var(--el-text-color-regular);
    font-size: 1rem;
}

.center {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
</style>